import Skelet from "../Skelet";
import {
  Avatar,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Accomplished from "./Accomplished";
import { useDatabase } from "../../contexts/DatabaseContext";
import { IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { db } from "../../firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";

function Achievements(props) {
  const { isAdmin, uid, undoneAchievements } = props;
  const { accomplishAchievement } = useDatabase();
  let data = <Skelet />;

  let handleAdd = (id) => {
    accomplishAchievement(uid, id);
  };

  let renderAchievements = (docs) => {
    return docs.map((doc, i) => {
      if (doc.data().active) {
        return (
          <ListItem
            key={i}
            alignItems="flex-start"
            secondaryAction={
              isAdmin ? (
                <IconButton
                  onClick={() => {
                    handleAdd(doc.id);
                  }}
                  edge="end"
                  aria-label="delete"
                >
                  <AddIcon />
                </IconButton>
              ) : null
            }
          >
            <ListItemAvatar>
              <Avatar src={doc.data().image} />
            </ListItemAvatar>
            <ListItemText
              primary={doc.data().name}
              secondary={
                <React.Fragment>{`${doc.data().points} баллов`}</React.Fragment>
              }
            />
          </ListItem>
        );
      }
    });
  };

  try {
    data = renderAchievements(undoneAchievements);
  } catch {}

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography
          fontFamily="Mossport"
          sx={{ fontSize: 25 }}
          color="text.secondary"
          gutterBottom
        >
          ЗАДАЧИ
        </Typography>
        <List sx={{ width: "100%", bgcolor: "background.paper" }}>{data}</List>
      </CardContent>
    </Card>
  );
}

Accomplished.propTypes = {
  isAdmin: PropTypes.any,
  uid: PropTypes.any,
};

export default Achievements;
